import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "text-lg font-serif font-semibold text-primary-800 mb-4" }
const _hoisted_3 = { class: "mb-6 p-4 bg-cream rounded-lg border border-sand" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex justify-between items-center mt-3" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-12 h-12 mx-auto mb-3 text-gray-300",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "No comments yet. Be the first to share your thoughts!", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_14 = { class: "flex items-start gap-3" }
const _hoisted_15 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "flex-shrink-0 w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center"
}
const _hoisted_18 = { class: "text-sm font-medium text-primary-700" }
const _hoisted_19 = { class: "flex-1 min-w-0" }
const _hoisted_20 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_21 = { class: "font-medium text-primary-800" }
const _hoisted_22 = { class: "text-xs text-gray-400" }
const _hoisted_23 = { class: "text-gray-700 whitespace-pre-wrap" }

import { ref, computed } from "vue";
import { useProposalStore } from "@/stores/proposals";


export default /*#__PURE__*/_defineComponent({
  props: {
  proposalId: {
    type: Number,
    required: true,
  },
  comments: {
    type: Array as () => ProposalComment[],
    default: () => [],
  },
},
  emits: ["comment-added"],
  setup(__props, { emit }) {

const props = __props





const proposalStore = useProposalStore();
const newComment = ref("");
const submitting = ref(false);
const error = ref("");

const sortedComments = computed(() => {
  return [...props.comments].sort((a, b) => {
    return new Date(b.created_on).getTime() - new Date(a.created_on).getTime();
  });
});

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
};

const submitComment = async () => {
  if (!newComment.value.trim() || newComment.value.length > 2000) return;

  submitting.value = true;
  error.value = "";

  try {
    const comment = await proposalStore.addComment(
      props.proposalId,
      newComment.value.trim()
    );
    newComment.value = "";
    emit("comment-added", comment);
  } catch (err: any) {
    error.value = err?.response?.data?.error || "Failed to post comment";
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, " Discussion (" + _toDisplayString(__props.comments.length) + ") ", 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newComment).value = $event)),
        placeholder: "Share your thoughts on this proposal...",
        rows: "3",
        class: "w-full p-3 text-sm border border-sand rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent resize-none bg-white",
        disabled: submitting.value
      }, null, 8, _hoisted_4), [
        [_vModelText, newComment.value]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(newComment.value.length) + " / 2000", 1),
        _createElementVNode("button", {
          onClick: submitComment,
          disabled: 
            !newComment.value.trim() || submitting.value || newComment.value.length > 2000
          ,
          class: "px-4 py-2 text-sm font-medium text-white bg-accent-700 rounded-lg hover:bg-accent-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        }, _toDisplayString(submitting.value ? "Posting..." : "Post Comment"), 9, _hoisted_7)
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.comments.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedComments), (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: comment.id,
              class: "p-4 bg-white rounded-lg border border-sand"
            }, [
              _createElementVNode("div", _hoisted_14, [
                (comment.author.profile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: comment.author.profile,
                        class: "w-10 h-10 rounded-full object-cover",
                        alt: ""
                      }, null, 8, _hoisted_16)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(comment.author.first_name.charAt(0)) + _toDisplayString(comment.author.last_name.charAt(0)), 1)
                    ])),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(comment.author.first_name) + " " + _toDisplayString(comment.author.last_name), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(comment.created_on)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(comment.content), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
  ]))
}
}

})